export default {
  // eslint-disable-next-line no-unused-vars
  transform: async (chunk, { Types, Promise, Mappers, Logger }) => {
    const brandMapper = Mappers('brand');
    const brands = await brandMapper
      .find({})
      .lean()
      .select('_id n');

    const newChunk = chunk.map(obj => {
      const newObject = { ...obj };
      if (!newObject.$set) {
        newObject.$set = {};
      }

      if (!newObject.$setOnInsert) {
        newObject.$setOnInsert = {};
      }

      newObject.$setOnInsert.e = true;
      newObject.$setOnInsert.dc = new Date();

      const brand = brands.find(
        b => `${b.n}`.toUpperCase() === `${newObject.$set.brand}`.toUpperCase(),
      );
      const alerts = newObject.$set.alerts || [];
      if (brand != null) {
        newObject.$set.brand = brand._id;
      } else {
        newObject.$set.brand = null;
        alerts.push({
          code: 'brand-invalid',
          level: 'warning',
        });
      }
      newObject.$set.alerts = alerts;
      return newObject;
    });

    return { chunk: newChunk };
  },
};



// WEBPACK FOOTER //
// ./src/configs/etl/masterproducts/masterProductsPayloadTransform.js